import { menuUserImg } from "assets/img";
import { Link } from "react-router-dom"
import { useAuth } from 'react-oidc-context';
import { UrlPath } from "utility/routes"
import { useCart } from "react-use-cart";



const UserNav = () => {

  const auth = useAuth();
  const cart = useCart();

  return (
    <>
      {!auth.isAuthenticated ? (
        <div className="text-end">
          <Link
            type="button"
            to=""
            className="text-white"
            onClick={() => void auth.signinRedirect()}
          >
            Logg inn
          </Link>
        </div>
      ) : (
        <>
          <div className="d-flex gap-4 align-items-center">
            {!cart.isEmpty ? <Link to={UrlPath.Account.ShoppingCartBase} className="d-inline text-white"><span className="d-none d-sm-inline">Handlekurv</span> <span className=""><i className="bi bi-cart2"></i>
              <i className={"bi bi-" + (cart.totalItems > 9 ? "9" : cart.totalItems) + "-circle-fill"} title={cart.totalItems > 9 ? cart.totalItems + " produkter" : ""}></i>
            </span></Link> : null}
            <div className="dropdown text-end cc-nav-dropdown">
              <span
                className="d-block text-decoration-none dropdown-toggle text-white"
                id="dropdownUser1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
              <span className="d-none d-sm-inline cc-user-info">{auth.user?.profile.given_name} {auth.user?.profile.family_name}</span>
                <i className="bi bi-list"></i>
              </span>
              <ul
                className="dropdown-menu text-small dropdown-menu-end shadow-sm"
                aria-labelledby="dropdownUser1"
              >
                <li>
                  <Link className="dropdown-item" to="/">
                    Mine bedrifter
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a className="dropdown-item" href="https://min.1881.no">Min side</a>
                </li>
                <li>
                  <Link className="dropdown-item" to="" onClick={() => { void auth.signoutRedirect() }}>
                    Logg ut
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default UserNav